import type { VoidFunctionComponent } from 'react';

import { FormLabelVariant, LabeledTextInput } from '../../../../../../generic';
import TeamSelector from './TeamsSelector/TeamSelector';
import styles from '../../ReleaseGroupsRevamp.module.less';
import TeamsBanner from './TeamsBanner/TeamsBanner';
import type { UseTeamsSelectOptionsReturn } from '../../../../../../shared/teams/hooks/useTeamsSelectOptions';
import type { ReleaseGroupState } from './hooks/useReleaseGroupState';

type PropsFromReleaseGroupState = 'name' | 'version' | 'setName' | 'setVersion';

type CommonProps = {
  title: string;
  description?: string;
  isNameVisible?: boolean;
};

type PropsWithoutTeams = {
  isTeamSelectorVisible?: false;
};

type PropsWithTeams = Pick<UseTeamsSelectOptionsReturn, 'teamOptions' | 'selectedTeamOptions' | 'onTeamsSelected'> & {
  isTeamSelectorVisible?: true;
};

type Props = CommonProps & (PropsWithoutTeams | PropsWithTeams) & Pick<ReleaseGroupState, PropsFromReleaseGroupState>;

const ReleaseGroupsDetails: VoidFunctionComponent<Props> = (props) => {
  return (
    <section className={styles.section}>
      <div className={styles.detailsTitle}>
        {props.title}
      </div>
      {props.description && (
        <div className={styles.detailsDescription}>
          {props.description}
        </div>
      )}
      <div className={styles.detailsInputs}>
        {props.isNameVisible && (
          <LabeledTextInput
            label="Name"
            onChange={props.setName}
            value={props.name}
            placeholder="New Release Group"
            size="small"
            labelVariant={FormLabelVariant.Filter}
          />
        )}
        <LabeledTextInput
          label="Version"
          onChange={props.setVersion}
          value={props.version}
          placeholder="1.0"
          size="small"
          labelVariant={FormLabelVariant.Filter}
        />
      </div>
      {props.isTeamSelectorVisible && (
        <TeamSelector
          teamOptions={props.teamOptions}
          selectedTeamOptions={props.selectedTeamOptions}
          onTeamsSelected={props.onTeamsSelected}
        />
      )}
      {props.isTeamSelectorVisible && props.selectedTeamOptions.length > 0 && (<TeamsBanner />)}
    </section>
  );
};

export default ReleaseGroupsDetails;
